import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/api/user.service';
import { PinModel } from 'src/app/models/pin.model';
import { ToastService } from 'src/app/services/toast.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BypassApiService } from 'src/app/services/api/bypass.service';
import { ProfileService } from 'src/app/services/profile.service';
import { ResponseCustomType } from 'src/app/types/response/response.type';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  standalone: false,
  selector: 'app-modal-pin',
  templateUrl: './modal-pin-verification.component.html',
  styleUrls: ['./modal-pin-verification.component.scss'],
})
export class ModalPinComponent implements OnInit {
  pin!: PinModel;
  settings: any = {
    length: 6,
    numbersOnly: true,
  };
  @Input() otpParams: any = {
    pin: '',
  };
  otp: string = '';
  isErrorMessage: boolean = false;
  destroy$ = new Subject();
  isDisabled: boolean = true;
  url: string = '';
  @Output() loading = new EventEmitter<any>();
  private profileSubscription!: Subscription;
  isEnterprise: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private userService: UserService,
    private router: Router,
    private toastService: ToastService,
    private byPassService: BypassApiService,
    private profileService: ProfileService,
    private message: NzMessageService,
  ) { }
  ngOnInit(): void {
    this.url = this.router.url;
    this.getProfile()
  }

  getProfile() {
    this.profileSubscription = this.profileService.profileData$.subscribe((data) => {
      if (data) {
        this.isEnterprise = data.rajaongkir_level === 3;
      }
    });
  }

  handleClose(e: any): void {
    this.activeModal.dismiss();
  }

  onChange(e: string) {
    this.otp = e;
    if (e.length === 6) {
      this.isDisabled = false;
    }
  }
  handleConfirm() {
    this.otpParams.pin = this.otp;
    if (this.isEnterprise) {
      this.userService
        .checkPin(this.otpParams)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            if (res.data.is_match === true) {
              this.pin = res.data;

              if (this.url === '/profile') {
                this.toastService.show(
                  null,
                  'Successfully viewed API Token',
                  'success',
                  {
                    classname: 'bg-success',
                    delay: 3000,
                  }
                );
              }
              this.loading.emit(res.data);
              this.activeModal.close(res.data);
            } else {
              this.toastService.show(
                null,
                'The PIN you entered is incorrect',
                'danger',
                {
                  classname: 'bg-danger',
                  delay: 3000,
                }
              );
              this.isErrorMessage = true;
            }
          },
          error: (err) => {
            this.message.create('error', err.error?.meta?.message || 'Verification failed');
          }
        });
    } else {
      this.byPassService
        .request<any>({
          method: 'GET',
          endpoint: `${environment.SWITCH_URL}/user/api/v1/user/check-pin`,
          params: this.otpParams
        })
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: ResponseCustomType<any>) => {
            if (res.data.is_match === true) {
              this.pin = res.data;

              if (this.url === '/profile') {
                this.toastService.show(
                  null,
                  'Successfully viewed API Token',
                  'success',
                  {
                    classname: 'bg-success',
                    delay: 3000,
                  }
                );
              }
              this.loading.emit(res.data);
              this.activeModal.close(res.data);
            } else {
              this.toastService.show(
                null,
                'The PIN you entered is incorrect',
                'danger',
                {
                  classname: 'bg-danger',
                  delay: 3000,
                }
              );
              this.isErrorMessage = true;
            }
          },
          error: (err) => {
            this.message.create('error', err.error.meta.message);
          }
        });
    }
  }
  onKeyDown(event: KeyboardEvent) {
    if (event.code === 'Backspace') {
      this.isErrorMessage = false;
      this.isDisabled = true;
    }
  }
}
